import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetBOUsersRPC } from "./getBoUsersRPC";

export class GetBOUsersRPCClientImpl extends GetBOUsersRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetBOUsersRPC.Request): Promise<LeoRPCResult<GetBOUsersRPC.Response, GetBOUsersRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/GetBOUsers",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetBOUsersRPC.ResponseDTO,
      GetBOUsersRPC.Errors.ErrorsDTO,
      GetBOUsersRPC.Response,
      GetBOUsersRPC.Errors.Errors
    >(
      response,
      "bo-user-management/GetBOUsers",
      GetBOUsersRPC.Response.fromDTO,
      GetBOUsersRPC.Errors.fromDTO
    );
  }
}
